import * as yup from 'yup';

// const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

export const updateShareholderValidation=yup.object({
    name:yup.string().required("Please Enter Name"),
    email:yup.string().email().required("Please Enter Email"),
    mobile:yup.number().typeError("That doesn't look like a phone number")
    .positive("A phone number can't start with a minus")
    .integer("A phone number can't include a decimal point")
    .required('A phone number is required')
    .min(8),
    newPassword: yup.string().nullable().min(8, 'New Password should be 8 chars minimum.'),

})